import styled from 'styled-components'

import { Input as DefaultInput } from '@subaio/webapp'

import { helpers } from 'styles'

export const Input = styled(DefaultInput)`
	height: 30px;
	text-align: right;
	max-width: 90px;
	/* Input wrapper has bottom margin */
	margin: 0 0 -18px;
	padding: 0 ${helpers.spacing.xSmall};
	z-index: 2;

	/* When styling the Input, we are actually styling the inputs container which holds most of the relevant styling. */
	/* But here we also want to force the height and alignment on the child input component inside the container. */
	> input {
		height: 30px;
		text-align: right;
	}
`
